const useRemoveRubyTags = (text: string | undefined): string => {
  if (text === undefined) {
    return '';
  }

  const rubyRemovedText = text.replace(/<ruby>|<rp>.*?<\/rp>|<\/ruby>|<rt>.*?<\/rt>/g, '');
  return rubyRemovedText;
};

export { useRemoveRubyTags };
